import { CompositeDecorator } from 'draft-js';
import { referenceDecorator } from './reference';
import { linkDecorator } from './link';
import { commentDecorator } from './comment';

export const decorators = [linkDecorator, referenceDecorator, commentDecorator];
export const createDecorators = () => new CompositeDecorator(decorators);
export const emptyDecorators = new CompositeDecorator([]);
